import { HttpParams } from '@angular/common/http';

export type QueryParams<T extends {}> = { [key in keyof T]: string };

export function createHttpParameters<T extends {}>(params: QueryParams<T>) {
  return coerceHttpParams(params);
}

export function coerceHttpParams<T extends {}>(params: T | null | undefined): HttpParams {
  let httpParams = new HttpParams();
  if (params != null) {
    Object.entries(params).forEach(([key, value]) => {
      if (value != null) {
        httpParams = httpParams.append(key, String(value));
      }
    });
  }
  return httpParams;
}
